// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Document = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Document = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Document = _exports.Document = function Document(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.625 2.5C5.29348 2.5 4.97554 2.6317 4.74112 2.86612C4.5067 3.10054 4.375 3.41848 4.375 3.75V16.25C4.375 16.5815 4.5067 16.8995 4.74112 17.1339C4.97554 17.3683 5.29348 17.5 5.625 17.5H14.375C14.7065 17.5 15.0245 17.3683 15.2589 17.1339C15.4933 16.8995 15.625 16.5815 15.625 16.25V8.75H11.25C10.7527 8.75 10.2758 8.55246 9.92417 8.20083C9.57254 7.84919 9.375 7.37228 9.375 6.875V2.5H5.625ZM10.625 3.38388L14.7411 7.5H11.25C11.0842 7.5 10.9253 7.43415 10.8081 7.31694C10.6908 7.19973 10.625 7.04076 10.625 6.875V3.38388ZM3.85723 1.98223C4.32607 1.51339 4.96196 1.25 5.625 1.25H9.48242C9.97953 1.25008 10.4564 1.44755 10.8079 1.79902L16.3259 7.31704C16.6774 7.66859 16.8749 8.14538 16.875 8.64248V16.25C16.875 16.913 16.6116 17.5489 16.1428 18.0178C15.6739 18.4866 15.038 18.75 14.375 18.75H5.625C4.96196 18.75 4.32607 18.4866 3.85723 18.0178C3.38839 17.5489 3.125 16.913 3.125 16.25V3.75C3.125 3.08696 3.38839 2.45107 3.85723 1.98223ZM6.25 11.25C6.25 10.9048 6.52982 10.625 6.875 10.625H13.125C13.4702 10.625 13.75 10.9048 13.75 11.25C13.75 11.5952 13.4702 11.875 13.125 11.875H6.875C6.52982 11.875 6.25 11.5952 6.25 11.25ZM6.25 14.375C6.25 14.0298 6.52982 13.75 6.875 13.75H13.125C13.4702 13.75 13.75 14.0298 13.75 14.375C13.75 14.7202 13.4702 15 13.125 15H6.875C6.52982 15 6.25 14.7202 6.25 14.375Z",
      fill: "currentColor"
    }));
  };
});
